<template>
  <div class="field-list listable">
    <div class="listable-head">
      <div class="th">
        <span class="text">Question</span>
      </div>
      <div class="th">
        <span class="text">Type</span>
      </div>
      <div class="th">
        <span class="text">Section</span>
      </div>
      <div class="th">
        <span class="text">Point Value</span>
      </div>
    </div>

    <Draggable class="listable-sortables" v-model="assigned">
      <div v-for="(field, f) in assigned" :key="`field_${f}`" class="listable-data">
        <div class="td">{{ field.content | strip_tags | shorten(100) }}</div>
        <div class="td">{{ fieldTypeLabel(field.type) }}</div>
        <div class="td">{{ field.section || "" }}</div>
        <div class="td">{{ field.points || 0 }}</div>
        <div class="td text-right">
          <ContextMenu :id="`field_menu_${f}`" :items="fieldMenu(field, f)" align="right" />
        </div>
        <div class="d-none">
          <input type="hidden" :name="`fields[${f}][id]`" :value="field.id" />
          <input type="hidden" :name="`fields[${f}][type]`" :value="field.type" />
          <input type="hidden" :name="`fields[${f}][section]`" :value="field.section" />
          <textarea :name="`fields[${f}][content]`" class="d-none" :value="field.content" />
          <input
            type="hidden"
            :name="`fields[${f}][include_in_bank]`"
            :value="!!field.include_in_bank ? 1 : 0"
          />

          <template v-if="isMatching(field)">
            <input
              v-for="(text, id) in field.options.a"
              :key="id"
              type="hidden"
              :name="`fields[${f}][options][a][${id}]`"
              :value="text"
            />
            <input
              v-for="(text, id) in field.options.b"
              :key="id"
              type="hidden"
              :name="`fields[${f}][options][b][${id}]`"
              :value="text"
            />
            <input
              v-for="(b, a) in field.answer"
              :key="a"
              type="hidden"
              :name="`fields[${f}][answer][${a}]`"
              :value="b"
            />
          </template>

          <template v-else-if="isMultipleChoice(field)">
            <input
              v-for="(text, id) in field.options"
              :key="id"
              type="hidden"
              :name="`fields[${f}][options][${id}]`"
              :value="text"
            />
            <input type="hidden" :name="`fields[${f}][answer]`" :value="field.answer" />
          </template>

          <template v-else-if="isCheckAll(field) || isSequence(field)">
            <input
              v-for="(text, id) in field.options"
              :key="id"
              type="hidden"
              :name="`fields[${f}][options][${id}]`"
              :value="text"
            />
            <input
              v-for="(id, a) in field.answer"
              :key="a"
              type="hidden"
              :name="`fields[${f}][answer][]`"
              :value="id"
            />
          </template>

          <template v-else>
            <input type="hidden" :name="`fields[${f}][options]`" :value="null" />
            <input type="hidden" :name="`fields[${f}][answer]`" :value="field.answer || null" />
          </template>
        </div>
      </div>
    </Draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export const fieldTypeMap = {
  CHECK_ALL_FIELD: "App\\Models\\Forms\\FieldTypes\\CheckAllField",
  MATCHING_FIELD: "App\\Models\\Forms\\FieldTypes\\MatchingField",
  MULTIPLE_CHOICE_FIELD: "App\\Models\\Forms\\FieldTypes\\MultipleChoiceField",
  SEQUENCE_FIELD: "App\\Models\\Forms\\FieldTypes\\SequenceField",
  TEXT_FIELD: "App\\Models\\Forms\\FieldTypes\\TextField",
  TRUE_FALSE_FIELD: "App\\Models\\Forms\\FieldTypes\\TrueFalseField"
};

export default {
  components: { Draggable },
  props: {
    assigned: { type: Array, default: () => [] },
    fieldTypes: { type: Array, required: true }
  },
  methods: {
    fieldTypeLabel(fieldType) {
      return this.fieldTypes.find(type => type.value == fieldType).label;
    },
    fieldMenu(field, index) {
      let selected = _.cloneDeep(field);
      return [
        {
          label: "Edit",
          action: () => {
            this.$emit("edit", selected);
          }
        },
        {
          label: "Remove",
          action: () => {
            this.$emit("remove", index);
          }
        }
      ];
    },
    isCheckAll(field) {
      return field.type == fieldTypeMap.CHECK_ALL_FIELD;
    },
    isMatching(field) {
      return field.type == fieldTypeMap.MATCHING_FIELD;
    },
    isMultipleChoice(field) {
      return field.type == fieldTypeMap.MULTIPLE_CHOICE_FIELD;
    },
    isSequence(field) {
      return field.type == fieldTypeMap.SEQUENCE_FIELD;
    },
    isText(field) {
      return field.type == fieldTypeMap.TEXT_FIELD;
    },
    isTrueFalse(field) {
      return field.type == fieldTypeMap.TRUE_FALSE_FIELD;
    }
  }
};
</script>